import { Link } from 'react-router';
import { DataTable } from '../components/DataTable.tsx';
import { ErrorState, LoadingState } from '../components/FdPrimitives.tsx';
import { useFetch } from '../hooks/useFetch.ts';

type Session = {
  session_id: string;
  device_alias: string;
  site_key: string;
  event_count: number;
  first_seen: string;
  last_seen: string;
};

export function SessionsPage() {
  const state = useFetch<{ sessions: Session[] }>('/sessions');

  if (state.status === 'loading') return <LoadingState label="Loading sessions" />;
  if (state.status === 'error') return <ErrorState message={state.message} />;

  return (
    <div className="page-stack">
      <DataTable
        title="Sessions"
        icon="timeline"
        rows={state.data.sessions}
        emptyTitle="No sessions found"
        emptyMessage="Session records will appear once browser events include a session id."
        columns={[
          {
            key: 'session_id',
            header: 'Session',
            className: 'cid',
            render: (s) => <Link to={`/sessions/${encodeURIComponent(s.session_id)}`}>{s.session_id}</Link>,
          },
          { key: 'device_alias', header: 'Device' },
          { key: 'site_key', header: 'Site key' },
          { key: 'event_count', header: 'Events' },
          { key: 'first_seen', header: 'First seen' },
          { key: 'last_seen', header: 'Last seen' },
        ]}
      />
    </div>
  );
}
